import { fetchJson } from "@otto-ec/assets-core-utils/nano-effect-web";
import type { CinemaDataDto } from "../types/CinemaProductsDto.types";
import type { Effect } from "@otto-ec/assets-core-utils/nano-effect";

export async function fetchCinemaProducts(
  variationId: string,
): Promise<Effect<CinemaDataDto, Error>> {
  return fetchJson<CinemaDataDto>(
    `/auction-otter/cinema/sponsored-products?variationId=${variationId}`,
    {
      method: "GET",
      headers: {},
    },
  );
}
